import { Record } from 'immutable';

export default class PreviewBookingSmsRecord extends Record({
  text: undefined,
  phoneNumber: undefined,
}) {
}
